import AccountIcon from '@mui/icons-material/AccountTreeRounded';
import PlayIcon from '@mui/icons-material/PlayArrowRounded';
import SearchIcon from '@mui/icons-material/Search';
import StopIcon from '@mui/icons-material/StopRounded';
import { CircularProgress, IconButton } from '@mui/material';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import useDecisionTreeContext from '../../Contexts/DecisionTree/DecisionTreeContext/useDecisionTreeContext';
import useProjectIdContext from '../../Contexts/ProjectContexts/ProjectIdContext/useProjectIdContext';
import useAudioConfigContext from '../../LiveContext/AudioConfigContext/useAudioConfigContext';
import useSessionContext from '../../LiveContext/SessionContextProvider/useSessionContext';
import useLiveContext from '../../LiveContext/useLiveContext';
import ContextSelector from '../MainWindow/Components/ContextSelector';
import StyledToolBar from './styles';

function SessionIcon() {
  const { session, sessionLoading } = useSessionContext();
  if (sessionLoading) return <CircularProgress size={42} />;
  if (session) return <StopIcon />;
  return <PlayIcon />;
}

export default function PluginToolbar() {
  const { isMounted, toggleMounted } = useDecisionTreeContext();
  const { projectId } = useProjectIdContext();
  const { deviceId } = useAudioConfigContext();
  const location = useLocation();

  const { search, setSearch } = useLiveContext();
  const { session, stopSession, startSession } = useSessionContext();

  const isHeadlessChrome = /\bHeadlessChrome\//.test(navigator.userAgent);
  return (
    <StyledToolBar className={clsx({ reduced: !!session })}>
      <IconButton
        onClick={() => { if (search === null) { setSearch(''); } else { setSearch(null); } }}
        className={clsx('standard', { active: search !== null })}
      >
        <SearchIcon />
      </IconButton>
      <IconButton
        onClick={() => {
          if (session) stopSession();
          else startSession();
        }}
        className={clsx('session', { active: !!session, inactiveSession: !!session?.isInactiveSession })}
        disabled={(!deviceId && !isHeadlessChrome) || !projectId}
        data-testid="session-button"
      >
        <SessionIcon />
      </IconButton>
      <IconButton
        className={clsx('standard', { active: isMounted || location.pathname === '/decision-trees' })}
        onClick={() => { toggleMounted(); }}
      >
        <AccountIcon />
      </IconButton>
      <ContextSelector />
    </StyledToolBar>
  );
}
